import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  adminGetAllUsersSuccess, adminGetAllUsersFail,
  activateFail, activateSuccess,
  deactivateSuccess, deactivateFail,
  setAdminSuccess, setAdminFail,
  unsetAdminSuccess, unsetAdminFail,
  deleteUserSuccess, deleteUserFail,
  adminGetAllUsersRequest
} from '../actions/admin';
import { serverError } from '../actions/common';
import api from '../api';


export function* getAllUsers() {
  try {
    const response = yield call([api, api.allPlayers]);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(adminGetAllUsersSuccess(response.users));
    } else {
      yield put(adminGetAllUsersFail());
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchGetAllUsers() {
  yield takeLatest('ADMIN_USERS_GET_ALL_USERS_REQUEST', getAllUsers);
}

export function* activateUser(action) {
  if (!action || !Object.hasOwn(action, 'short')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const response = yield call([api, api.setActive], action.short, true);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(activateSuccess(action.short));
      yield put(adminGetAllUsersRequest());
    } else {
      yield put(activateFail(action.short));
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchActivateUser() {
  yield takeLatest('ADMIN_USERS_ACTIVATE_REQUEST', activateUser);
}

export function* deactivateUser(action) {
  if (!action || !Object.hasOwn(action, 'short')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const response = yield call([api, api.setActive], action.short, false);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(deactivateSuccess(action.short));
      yield put(adminGetAllUsersRequest());
    } else {
      yield put(deactivateFail(action.short));
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchDeactivateUser() {
  yield takeLatest('ADMIN_USERS_DEACTIVATE_REQUEST', deactivateUser);
}

export function* setUserToAdmin(action) {
  if (!action || !Object.hasOwn(action, 'short')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const response = yield call([api, api.setAdmin], action.short, true);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(setAdminSuccess(action.short));
      yield put(adminGetAllUsersRequest());
    } else {
      yield put(setAdminFail(action.short));
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchSetUserToAdmin() {
  yield takeLatest('ADMIN_USERS_SET_ADMIN_REQUEST', setUserToAdmin);
}

export function* unsetUserFromAdmin(action) {
  if (!action || !Object.hasOwn(action, 'short')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const response = yield call([api, api.setAdmin], action.short, false);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(unsetAdminSuccess(action.short));
      yield put(adminGetAllUsersRequest());
    } else {
      yield put(unsetAdminFail(action.short));
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchUnsetUserFromAdmin() {
  yield takeLatest('ADMIN_USERS_UNSET_ADMIN_REQUEST', unsetUserFromAdmin);
}

export function* deleteUser(action) {
  if (!action || !Object.hasOwn(action, 'short')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const response = yield call([api, api.removePlayer], action.short);
    if (!response) {
      yield put(serverError(['Fetch failed']));
      return;
    }
    if (response.statusCode === 200) {
      yield put(deleteUserSuccess(action.short));
      yield put(adminGetAllUsersRequest());
    } else {
      yield put(deleteUserFail(action.short));
    }
  } catch {
    yield put(serverError(['Fetch failed']));
  }
}
export function* watchDeleteUser() {
  yield takeLatest('ADMIN_USERS_DELETE_REQUEST', deleteUser);
}

export default function* adminSaga() {
  yield all([
    fork(watchGetAllUsers),
    fork(watchActivateUser),
    fork(watchDeactivateUser),
    fork(watchSetUserToAdmin),
    fork(watchUnsetUserFromAdmin),
    fork(watchDeleteUser)
  ]);
}
